import React, {useState} from 'react';
import ReasoningDialog from '../../pages/CallDetailsPage/components/ReasoningDialog';
import styles from './styles.module.scss';

const QuestionIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.2"/>
        <path d="M5.5 5.5C5.5 4.67 6.17 4 7 4C7.83 4 8.5 4.67 8.5 5.5C8.5 6.33 7 7 7 7.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
        <circle cx="7" cy="9.5" r="0.6" fill="currentColor"/>
    </svg>
);

const ExclamationIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.2"/>
        <path d="M7 4V7.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
        <circle cx="7" cy="9.5" r="0.6" fill="currentColor"/>
    </svg>
);

interface IProps {
    companyId: number;
    phonecallUuid: string;
    checklistId: number;
    itemUuid: string;
    questionLabel: string;
    className?: string;
    variant?: 'question' | 'exclamation';
}

const ReasoningButton: React.FC<IProps> = ({companyId, phonecallUuid, checklistId, itemUuid, questionLabel, className, variant = 'question'}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                className={[styles.btn, variant === 'exclamation' && styles.btn_exclamation, className].filter(Boolean).join(' ')}
                title="Обґрунтування"
                onClick={() => setIsOpen(true)}
            >
                {variant === 'exclamation' ? <ExclamationIcon /> : <QuestionIcon />}
            </button>

            {isOpen && (
                <ReasoningDialog
                    companyId={companyId}
                    phonecallUuid={phonecallUuid}
                    checklistId={checklistId}
                    itemUuid={itemUuid}
                    questionLabel={questionLabel}
                    handleClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
};

export default ReasoningButton;
